const UI_BASE_URL = 'https://alradwan-medical.com';

export const product = UI_BASE_URL + '/product';

export const news = UI_BASE_URL + '/event';